/* eslint-disable no-prototype-builtins */
import { useCallback, useEffect, useRef, useState } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../app/hooks'

import { FixMeLater } from 'types'
import uploadApi from 'app/axiosApi'
import { UserStatus } from 'types/user.types'
import { usersActions } from 'app/slices/users.slice'
import { useLazyGetRoomsQuery } from 'app/services/room.service'
import { useUpdateUserFcmMutation } from 'app/services/user.service'
import useHandleNotification from 'utils/hooks/useHandleNotification'
// import { useGetAllMessagesMutation } from 'app/services/conversation.service'

import NavigationBar from 'components/navigation-bar/NavigationBar'

import { MainLayout } from './rStyled'
import {
  useLazyGetRealNotificationCountQuery,
  useLazyGetUnreadPostsQuery,
  useLazyGetPaginatedPostsQuery,
  useLazyUnreadPostNotificationQuery,
} from 'app/services/post.service'
import { useLazyGetChannelsQuery } from 'app/services/group.service'
//import { useGetUserConferencesByUserIdMutation } from 'app/services/conference.service'
import { otrActions } from 'app/slices/otr.slice'
import { useSocket } from 'utils/hooks/useSocket'
import { newsFeedActions } from 'app/slices/news-feed.slice'
import useWindowDimensions from 'utils/hooks/useWindowDimensions'
import DropdownSocket from 'components/dropdown-socket/DropdownSocket'
import { useLazyGetReconnectedMessagesQuery } from 'app/services/conversation.service'
import { conversationActions } from 'app/slices/conversations.slice'
import { useLazyGetSystemQuery } from 'app/services/system.service'
import { IRolePermissions, NewsFeedPermissions } from 'types/role.types'
import { isFlagSetIn } from 'utils/helpers/isSetInFlags'
import { getDataFromDB } from 'utils/helpers/storageHelper'
import { useCheckCookieSafeMutation, useGetTokenMutation } from 'app/services/auth.service'
import { tokenReceived } from 'app/slices/actions'
import useWindowFocus from 'utils/hooks/useWindowFocus'





export default function ProtectedMainLayout() {
  const [didFetchAllData, setDidFetchAllData] = useState(false)

  // const [isConnected, setIsConnected] = useState(true);
  const dispatch = useAppDispatch()
  const socket = useSocket()
  const { id: myId = '', accessToken = '', user, expire, refreshToken= '' } = useAppSelector((state) => state.auth)
  const messagesData = useAppSelector((state) => state.message.data)
  const { screenHeight } = useWindowDimensions()
  const location = useLocation()

  const [getRooms]: FixMeLater = useLazyGetRoomsQuery()
  const [getChannels]: FixMeLater = useLazyGetChannelsQuery()
  const [getPostsWithPageIndex] = useLazyGetPaginatedPostsQuery()
  const [getUnreadPosts] = useLazyGetUnreadPostsQuery()
  const [getNewsFeedNotifCount] = useLazyGetRealNotificationCountQuery()
  const [getSystemSettings] = useLazyGetSystemQuery()
  const [updateFcm] = useUpdateUserFcmMutation()
  const [getToken] = useGetTokenMutation();
  const systemSettings = useAppSelector((state) => state.system.data)
  const isFocus = useWindowFocus()
  const [checkCookieSafe] = useCheckCookieSafeMutation()

  const [reconnectionAttemptCount, setReconnectionAttemptCount] = useState(0)
  const [
    getUnreadNotificatonCount,
    { data: unreadNotificationData, isSuccess: isGetUnreadNotificationSuccess },
  ] = useLazyUnreadPostNotificationQuery()
  // const [getMyConferences, { data, isSuccess: getConferences }] =
  //   useGetUserConferencesByUserIdMutation()

  const permissions = useAppSelector<IRolePermissions>((state) => state.auth.permissions)
  

  const hasViewNewsFeed = isFlagSetIn([NewsFeedPermissions.VIEW_NEWSFEED], permissions.newsFeed)
  //const socketRef = useRef<any>(socket);
  const isVideoCall = location.pathname.startsWith('/video-conference') || location.pathname.startsWith('/join')


  useHandleNotification()

  const [getReconnectedMessages] = useLazyGetReconnectedMessagesQuery()


  const myLocation = location.pathname.split('/')?.[1]
  const roomId = location.pathname.split('/')?.[2]

  useEffect(() => {
    const handleBeforeUnload = () => {
      if (socket && socket.connected) {
        // socket.disconnect()
        // socket.io.engine.close();
      }
    }

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        handleBeforeUnload()
      }
    })

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
      window.removeEventListener('visibilitychange', handleBeforeUnload)
    }
  }, [])

  useEffect(() => {
    const vh = screenHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  }, [screenHeight])

  useEffect(() => {
    if (reconnectionAttemptCount >= 3) {
      DropdownSocket.ref.show()
    }
  }, [reconnectionAttemptCount])



  const requestLockedRef = useRef(false);
  const refreshTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  
  const REFRESH_BEFORE_MS = 4 * 60 * 60 * 1000; // 4 saatlik refresh
  
  const clearRefreshTimer = useCallback(() => {
    if (refreshTimerRef.current) {
      clearTimeout(refreshTimerRef.current);
      refreshTimerRef.current = null;
    }
  }, []);
  
  const refreshAccessToken = useCallback(async () => {
    if (!refreshToken) return;
    if (requestLockedRef.current) return;
  
    requestLockedRef.current = true;
  
    try {
      console.log("[TOKEN REFRESH START]", new Date().toLocaleString());
  
      const result = await getToken(refreshToken).unwrap();
  
      dispatch(
        tokenReceived({
          accessToken: result.accessToken,
          refreshToken: result.refreshToken ?? refreshToken,
        })
      );
  
      console.log("[TOKEN REFRESH SUCCESS]", new Date().toLocaleString());
    } catch (err) {
      console.error("[TOKEN REFRESH ERROR]", err);
    } finally {
      requestLockedRef.current = false;
    }
  }, [refreshToken, getToken, dispatch]);
  
  useEffect(() => {
    clearRefreshTimer();
  
    if (!expire || !refreshToken) return;
  
    const expireTime = expire * 1000;
    const refreshAt = expireTime - REFRESH_BEFORE_MS;
    const delay = Math.max(refreshAt - Date.now(), 0);
  
    console.log("[TOKEN TIMER SET]", {
      now: new Date().toLocaleString(),
      expireTime: new Date(expireTime).toLocaleString(),
      refreshAt: new Date(refreshAt).toLocaleString(),
      delay,
    });
  
    refreshTimerRef.current = setTimeout(() => {
      console.log("[TOKEN TIMER EXPIRED BEFORE REFRESH]", new Date().toLocaleString());
      refreshAccessToken();
      console.log("[TOKEN TIMER EXPIRED AFTER REFRESH]", new Date().toLocaleString());
    }, delay);
  
    return clearRefreshTimer;
  }, [expire, refreshToken, refreshAccessToken, clearRefreshTimer]);
  
  useEffect(() => {
    if (!expire || !refreshToken) return;
  
    const checkOnFocus = () => {
      const expireTime = expire * 1000;
      const shouldRefresh = expireTime - Date.now() <= REFRESH_BEFORE_MS;
  
      console.log("[TOKEN FOCUS CHECK]", {
        isFocus,
        shouldRefresh,
        now: new Date().toLocaleString(),
        expireTime: new Date(expireTime).toLocaleString(),
      });
  
      if (shouldRefresh) {
        refreshAccessToken();
      }
    };
  
    if (isFocus) {
      checkOnFocus();
    }
  }, [isFocus, expire, refreshToken, refreshAccessToken]);


  useEffect(() => {
    const run = async () => {
      if (!refreshToken) return;
  
      try {
        const res = await checkCookieSafe({ refreshToken }).unwrap();
        console.log("[CHECK COOKIE SAFE]", res);
  
        if (res?.accessToken) {
          dispatch(
            tokenReceived({
              accessToken: res.accessToken,
              refreshToken: res.refreshToken ?? refreshToken,
            })
          );
        }
      } catch (err) {
        console.error("[CHECK COOKIE SAFE ERROR]", err);
      }
    };
  
    run();
  }, [refreshToken, checkCookieSafe, dispatch]);

  const initializedRef = useRef(false);
  const [authReady, setAuthReady] = useState(false);
  
  useEffect(() => {
    console.log("[AUTH INITIALIZATION START]", new Date().toLocaleString());
    if (initializedRef.current) return;
    if (!expire || !refreshToken) return;
  
    initializedRef.current = true;
  
    async function initAuth() {
      const expireTime = expire * 1000;
      const shouldRefresh = expireTime - Date.now() <= REFRESH_BEFORE_MS;
  
      if (shouldRefresh) {
        console.log("[AUTH INITIALIZATION REFRESH TOKEN]", new Date().toLocaleString());
        await refreshAccessToken();
      }
  
      setAuthReady(true);
      console.log("[AUTH INITIALIZATION SUCCESS]", new Date().toLocaleString());
    }
  
    initAuth();
  }, [expire, refreshToken, refreshAccessToken]);





  useEffect(() => {
    if (!accessToken || shouldShowKvkkModal(user?.isKvkkAccepted ?? false)) return
    _getAllInitials()
    async function _getAllInitials() {
      uploadApi.setHeader(accessToken)
      dispatch(newsFeedActions.postLoading(true))
      if (hasViewNewsFeed) {
        await getPostsWithPageIndex({ page: 0})
      }
      try {
        const promises = [getRooms(), getChannels(), getSystemSettings({})]

        if (hasViewNewsFeed) {
          promises.push(getUnreadNotificatonCount({}))
          promises.push(getNewsFeedNotifCount({}))
        }


        const [roomsResponse] = await Promise.all(promises)

        if (roomsResponse.isSuccess) {
          const otrRooms = roomsResponse.data.data.filter((room: FixMeLater) => room.invitedUsers)
          otrRooms.forEach((room: FixMeLater) => {
            dispatch(
              otrActions.createOtrRoom({
                timeout: null,
                roomId: room._id,
                requestSentAt: room.createdAt,
              }),
            )
          })
          socket.emit('join-otr-rooms', { data: otrRooms })
        }

        if (Notification.permission === 'granted') {
          const fcmToken = await getDataFromDB('vimesoft', 'fcmToken')
          if (fcmToken) {
            await updateFcm({ fcmToken: fcmToken })
          }
        }
      } catch (error) {
        console.error('Initial Error:', error)
      } finally {
        onFetchAllData()
      }
    }
    return () => {
      socket.off('join-otr-rooms')
    }
  }, [])

  useEffect(() => {
    socket.io.on('reconnect', async () => {
      DropdownSocket.ref.hide()
      setReconnectionAttemptCount(0)
      console.log('re-connected again...')
      if (myLocation === 'channels' || myLocation === 'messages') {
        const messages = messagesData?.[roomId]?.messages || []
        const myLastMessageDate =
          messages.filter((item: FixMeLater) => item.hasOwnProperty('_id'))?.[0]?.createdAt || ''
        const data: FixMeLater = await getReconnectedMessages({ roomId, createdAt: myLastMessageDate })
        if (data?.data) {
          dispatch(conversationActions.getReconnectedMessages({ roomId, data: data?.data }))
          dispatch(conversationActions.exceptionalClearAllMessages({ roomId }))
          dispatch(newsFeedActions.clearAllPost())
        }
      }
      if (myLocation === 'news-feed') {
        dispatch(conversationActions.clearAllMessages())
        const { data }: FixMeLater = await getUnreadPosts({})
        dispatch(newsFeedActions.addUnreadPost(data))
      }
    })

    if (accessToken) {
      socket.on('connect_error', () => {
        setReconnectionAttemptCount((prevCount) => ++prevCount)
      })
    }

    return () => {
      socket.io.off('reconnect')
      socket.off('connect_error')
    }
  }, [messagesData, roomId, myLocation])

  const shouldShowKvkkModal = useCallback((userKvkkStatus: boolean): boolean => {
    if (!systemSettings?.features?.isPrivacyTextEnabled) return false
    return !userKvkkStatus
  }, [systemSettings?.features?.isPrivacyTextEnabled])

  useEffect(() => {
    //if (isSuccess) {
    //if (isSuccess) {
//    dispatch(usersActions.updateUsersStatus({ userId: myId, status: UserStatus.ONLINE }))
    //}
    //if (getConferences) {
    //  dispatch(conferenceActions.fillInitialState(data.data))
    //}
    if (isGetUnreadNotificationSuccess) {
      dispatch(newsFeedActions.setInitialUnreadPostCount({ count: unreadNotificationData.data }))
    }
  }, [isGetUnreadNotificationSuccess])

  if (!accessToken || shouldShowKvkkModal(user?.isKvkkAccepted ?? false)) {
    return <Navigate to="/login" />
  }

  function onFetchAllData() {
    dispatch(newsFeedActions.resetUnreadPostCount())
    setDidFetchAllData(true)
    dispatch(newsFeedActions.postLoading(false))
  }

  if (!authReady) {
    return null; 
  }

  return (
    <MainLayout>
      {!isVideoCall && <NavigationBar />}
      <Outlet context={{ didFetchAllData }} />
    </MainLayout>
  )
}
